import React from 'react';
import { DescriptionIcon } from '../../Builder/EntitySelection/node/NodeIcon';
import {
  IEntityNode,
  ISelectedEntity,
} from '../../Builder/EntitySelection/types';
import DictionaryEntityFavorite from '../DictionaryEntityFavorite';
import * as DictionaryEntityDetailsUI from './DictionaryEntityDetailsUI';
import DictionaryBasicEventDetails from './DictionaryBasicEventDetails';
import DictionaryEntityBasicDetails from './DictionaryEntityBasicDetails';
import DictionaryFieldDetails from './DictionaryFieldDetails';
import DictionaryEntityVersionDetails from './DictionaryEntityVersionDetails';
import { IconWrapper } from '../../Icon';

interface IProps {
  schemaId: string;
  entity: ISelectedEntity;
  node: IEntityNode;
  onRefresh: () => void;
}

const DictionaryEntityDetails = ({
  schemaId,
  node,
  entity,
  onRefresh,
}: IProps) => {
  const renderEntityDetails = () => {
    if (entity.__typename === 'BasicEventValue') {
      return <DictionaryBasicEventDetails basicEvent={entity} />;
    } else if (
      entity.__typename === 'VirtualEvent' ||
      entity.__typename === 'NamedFilter'
    ) {
      return <DictionaryEntityBasicDetails entity={entity} />;
    } else if (entity.__typename === 'Field') {
      return <DictionaryFieldDetails entity={entity} />;
    } else if (
      entity.__typename === 'CompoundMeasure' ||
      entity.__typename === 'SimpleMeasure' ||
      entity.__typename === 'CompoundCohort' ||
      entity.__typename === 'ExpressionCohort' ||
      entity.__typename === 'FunnelCohort' ||
      entity.__typename === 'MeasureCohort' ||
      entity.__typename === 'PerformedCohort' ||
      entity.__typename === 'RetentionCohort'
    ) {
      return <DictionaryEntityVersionDetails entity={entity} />;
    } else {
      return null;
    }
  };

  return (
    <DictionaryEntityDetailsUI.Container>
      <DictionaryEntityDetailsUI.Header>
        <IconWrapper size={24}>
          <DescriptionIcon node={node} />
        </IconWrapper>
        <DictionaryEntityDetailsUI.Title>
          {node.name}
        </DictionaryEntityDetailsUI.Title>
        <DictionaryEntityFavorite
          schemaId={schemaId}
          entity={entity}
          onRefresh={onRefresh}
        />
      </DictionaryEntityDetailsUI.Header>
      {renderEntityDetails()}
    </DictionaryEntityDetailsUI.Container>
  );
};

export default DictionaryEntityDetails;
